/**
 * Source de vérité unique pour l'état Premium côté front web.
 * Aligné sur le helper backend (src/utils/premium.js).
 * Lit `user.plan` et `user.finAbonnement` retournés par GET /api/auth/profil.
 */
export function isPremium(user) {
  if (!user) return false;
  if (user.plan !== 'premium') return false;
  if (user.finAbonnement && new Date(user.finAbonnement) < new Date()) return false;
  return true;
}
